import { IMAGE_SIZE } from "@/utils/constants/size";
import React, { CSSProperties } from "react";

export type ImageSize = "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "flex";

export type ImageProps = React.ComponentProps<"img"> & {
  size?: ImageSize | number;
  objectFit?: CSSProperties["objectFit"];
};

const Image = ({ size = "md", objectFit = "contain", ...rest }: ImageProps) => {
  const imageSize = typeof size === "number" ? `${size}px` : IMAGE_SIZE[size];
  return (
    <img
      {...rest}
      style={{
        height: imageSize,
        width: imageSize,
        objectFit,
      }}
    />
  );
};

export default Image;
